<template>
  <v-form
    v-model="state.isValidForm"
    data-qa="card_getting_email_enter"
    @submit.prevent="$emit(events.club.cardGettingEmailSent, state.emailValue)"
  >
    <div class="text-h6 text--text mb-2 text-left">
      Введите Email
    </div>
    <div class="text-body-1 text-secondary--text mb-4 text-left">
      Вышлем чек
    </div>
    <v-text-field
      v-model="state.emailValue"
      :rules="componentData.emailValidationRules"
      :append-icon="componentData.vuetifyIcons.emailIcon"
      label="Email"
      data-qa="card_getting_email_enter_input"
      outlined
    />
    <div class="d-flex justify-end">
      <v-btn
        type="submit"
        text
        :disabled="isDisabledSendButton"
        :color="componentData.vuetifyColors.primary"
        data-qa="card_getting_email_enter_submit"
      >
        Отправить
      </v-btn>
    </div>
  </v-form>
</template>

<script>
import { getEmailValidation } from 'www/utils'
import { eventsData } from 'www/vue_components/common/Club/components/core/ClubCardGetting/interfaces'

const {
  regex,
  onlyEn,
  required,
  maxLength,
} = getEmailValidation()

export default {
  name: 'ClubCardGettingEmailEnter',
  data: vm => ({
    events: eventsData,
    state: {
      emailValue: '',
      isValidForm: false,
    },
    componentData: {
      vuetifyIcons: vm.$vuetify.icons.values,
      vuetifyColors: vm.$vuetify.theme.themes.light,
      emailValidationRules: [
        required,
        maxLength,
        onlyEn,
        regex,
      ],
    },
  }),
  computed: {
    isDisabledSendButton() {
      return !this.state.isValidForm || !this.state.emailValue.length
    },
  },
}
</script>
